/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { useNavigate } from '@reach/router';
import { Button, Grid, Typography } from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import Lightning from '../../../components/Icons/Lightning';
import { TiTick } from '@react-icons/all-files/ti/TiTick';
import { TiTimes } from '@react-icons/all-files/ti/TiTimes';

import css from './index.module.scss';

function LightningPayStatus({ success, onClose, tryAgain, redirectToThankyouPage }) {
  const intl = useIntl();
  const navigate = useNavigate();
  // const closePopup = () => {
  //   navigate(-1);
  // };

  return (
    <>
      {/* <Grid className={css.root}>
        <Badge />
      </Grid> */}
      <Grid className={css.confettiBody}>
        <Grid className={[css.circle, success ? '' : css.circleFail].join(' ')}>
          {success ? <Lightning className={css.icon} /> : <TiTimes className={css.icon} />}
        </Grid>
        <Grid className={css.warningHeadText}>
          <Typography>
            {success ? (
              <FormattedMessage id="woohoo" defaultMessage="Woohoo!" />
            ) : (
              <FormattedMessage id="lightning_pay_fail_oops" defaultMessage="oops!" />
            )}
          </Typography>
        </Grid>
        <Grid className={css.description}>
          <Typography>
            {success ? (
              intl.locale == 'en' ? (
                <>
                  <FormattedMessage id="lightning_pay_payment_success1" />
                  <span className={css.mustardText}>
                    <FormattedMessage id="lightning_pay_payment_success2" />
                  </span>
                  <FormattedMessage id="lightning_pay_payment_success3" />
                </>
              ) : (
                <FormattedMessage id="lightning_pay_payment_success" defaultMessage="Woohoo!" />
              )
            ) : (
              <FormattedMessage id="lightning_pay_payment_fail" defaultMessage="oops!" />
            )}
          </Typography>
        </Grid>
        {/* <Grid className={css.subDescription}>
          <Typography>
            {success ? (
              <FormattedMessage
                id="lightning_pay_payment_description_success"
                defaultMessage="Woohoo!"
              />
            ) : (
              <FormattedMessage
                id="lightning_pay_payment_description_fail"
                defaultMessage="oops!"
              />
            )}
          </Typography>
        </Grid> */}
        <Grid className={css.buttonContainer}>
          <Button className={css.button} onClick={success ? onClose : tryAgain}>
            {success ? (
              <FormattedMessage id="offer_gotit" defaultMessage="gotit!" />
            ) : (
              <FormattedMessage id="lightning_pay_try_again" defaultMessage="try_again" />
            )}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

export default LightningPayStatus;
